module.exports = __webpack_public_path__ + "static/img/workorder.165b88f7.svg";